import { apiClient } from '../../services/api';

/**
 * Get all correspondence (attorney view)
 */
export async function getCorrespondence(options = {}) {
  const params = new URLSearchParams();
  if (options.status) params.append('status', options.status);
  if (options.classification) params.append('classification', options.classification);
  if (options.applicationId) params.append('applicationId', options.applicationId);
  if (options.limit) params.append('limit', options.limit);

  const queryString = params.toString();
  const url = queryString ? `/correspondence?${queryString}` : '/correspondence';

  const response = await apiClient.get(url);
  return response.data;
}

/**
 * Get a single correspondence item
 */
export async function getCorrespondenceItem(id) {
  const response = await apiClient.get(`/correspondence/${id}`);
  return response.data;
}

/**
 * Link correspondence to an application
 */
export async function linkCorrespondence(correspondenceId, applicationId) {
  const response = await apiClient.post(`/correspondence/${correspondenceId}/link`, {
    applicationId
  });
  return response.data;
}

/**
 * Mark correspondence as processed
 */
export async function markProcessed(correspondenceId, notes) {
  const response = await apiClient.post(`/correspondence/${correspondenceId}/process`, {
    notes
  });
  return response.data;
}

/**
 * Manual match correspondence with AI learning feedback
 * @param {string} correspondenceId - Correspondence ID to match
 * @param {object} matchData - Match data including correct values and feedback
 * @param {object} matchData.correct - Correct values (applicationId, classification, etc.)
 * @param {object} matchData.feedback - AI learning feedback (failureCategory, infoLocations, notes)
 */
export async function manualMatch(correspondenceId, matchData) {
  const response = await apiClient.patch(`/correspondence/${correspondenceId}`, {
    action: 'manual_match',
    ...matchData
  });
  return response.data;
}

export default {
  getCorrespondence,
  getCorrespondenceItem,
  linkCorrespondence,
  markProcessed,
  manualMatch
};
